import React from "react";

import { useGetApplicationQuery } from "EmployeeApplication/api";
import { TermLifePage } from "EmployeeCoverage/Components/TermLife";
import { Link } from "react-router-dom";
import BasicLoading from "ZeroRuby/BasicLoading";

import BodyText from "Cobalt/BodyText";
import { CardSection } from "Cobalt/Card";
import { RoutedBackButton } from "Common/forms/buttons";

import MissingZipCode from "./components/MissingZipCode";
import Page from "./Page";

const NoCoverageOffered = () => (
  <CardSection>
    <BodyText size="large" agent>
      Your company does not offer term life insurance at this time.
    </BodyText>
  </CardSection>
);

const useData = () => {
  const { isLoading: isLoadingApplication, data: { employeePolicy: { employeeForm: { zipCode } = {} } = {}, availablePlans = [] } = {} } =
    useGetApplicationQuery();

  return {
    isLoadingApplication,
    offeringTermLife: availablePlans.includes("term_life"),
    missingZipCode: !zipCode,
  };
};

const PageContent = () => {
  const { isLoadingApplication, missingZipCode, offeringTermLife } = useData();

  if (isLoadingApplication) {
    return (
      <CardSection>
        <BasicLoading />
      </CardSection>
    );
  }
  if (missingZipCode) {
    return (
      <CardSection>
        <MissingZipCode />
      </CardSection>
    );
  }
  if (!offeringTermLife) {
    return (
      <CardSection>
        <NoCoverageOffered />
      </CardSection>
    );
  }
  return <TermLifePage />;
};

const ChooseTermLifeCoveragePage = ({ backLink, onClickBack }) => (
  <Page title="Choose Term Life Coverage">
    <PageContent />
    <CardSection>
      <RoutedBackButton href={backLink} onClick={onClickBack} />
    </CardSection>
  </Page>
);

export default ChooseTermLifeCoveragePage;
